/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type DreamScanRuleMatch =
  (typeof DreamScanRuleMatch)[keyof typeof DreamScanRuleMatch];

export const DreamScanRuleMatch = {
  exact: "exact",
  regex: "regex",
} as const;
